import { UndefinedEntityError } from './undefinedEntity'

export class AuthorizationError extends UndefinedEntityError {
  constructor(functionName?: string) {
    super('token', functionName)
  }
}
